(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Header2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  /* Open desktop menu on hover (controlled by theme setting) */
  (function () {
    if (window.__menuHoverInit) return;
    window.__menuHoverInit = true;

    var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    var CLOSE_DELAY = 150;

    function hoverEnabled() {
      var wrap = document.querySelector('.header-wrapper');
      return mq.matches && wrap && wrap.getAttribute('data-menu-hover') === 'true';
    }

    function setOpen(details, open) {
      var summary = details.querySelector('summary');
      if (details.open === open) return;
      details.open = open;
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function bind(menu) {
      if (menu.__hoverBound) return;
      menu.__hoverBound = true;

      var details = menu.querySelector('details');
      var summary = menu.querySelector('summary');
      if (!details || !summary) return;

      var timer;

      menu.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !hoverEnabled()) return;
        clearTimeout(timer);
        // doosre open menus band karo
        document.querySelectorAll('.header-wrapper header-menu details[open]').forEach(function (d) {
          if (d !== details) setOpen(d, false);
        });
        setOpen(details, true);
      });

      menu.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse' || !hoverEnabled()) return;
        timer = setTimeout(function () {
          setOpen(details, false);
        }, CLOSE_DELAY);
      });

      // Mouse click par menu band na ho (hover se khula hai); keyboard Enter/Space (detail === 0) normal chalega
      summary.addEventListener(
        'click',
        function (e) {
          if (!hoverEnabled() || e.detail === 0) return;
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
    }

    function init() {
      document.querySelectorAll('.header-wrapper header-menu').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Theme editor me section reload ho to dobara bind
    document.addEventListener('shopify:section:load', init);
  })();
  /* Distribution page: smooth scroll to section, keep #id out of the URL */
  (function () {
    if (window.__distAnchorInit) return;
    window.__distAnchorInit = true;

    function findTarget(hash) {
      if (!hash || hash.length < 2) return null;
      try {
        return document.getElementById(decodeURIComponent(hash.slice(1)));
      } catch (err) {
        return null;
      }
    }

    function scrollToTarget(target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('.header--distribution a[href*="#"]');
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (err) {
        return;
      }

      if (url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;

      var target = findTarget(url.hash);
      if (!target) return;

      e.preventDefault();

      var drawer = link.closest('header-drawer');
      var drawerOpen = drawer && drawer.querySelector('details[open]');
      if (drawerOpen) {
        // drawer.closeMenuDrawer(e, drawer.querySelector('summary'));
        var summaryEl = drawer.querySelector('summary');
        drawer.closeMenuDrawer(e, summaryEl);
        if (summaryEl) summaryEl.setAttribute('aria-expanded', 'false');
        setTimeout(function () {
          scrollToTarget(target);
        }, 150);
      } else {
        scrollToTarget(target);
      }
    });

    /* If the page is opened with #id (e.g. from another page), scroll and clean the URL */
    window.addEventListener('load', function () {
      if (!document.querySelector('.header--distribution')) return;
      var target = findTarget(window.location.hash);
      if (!target) return;
      setTimeout(function () {
        scrollToTarget(target);
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logistics-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 2000; // ms
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function parse(text) {
      var m = text.trim().match(/^([^\d]*)(\d[\d.,]*)(.*)$/);
      if (!m) return null;
      var numStr = m[2];
      var value = parseFloat(numStr.replace(/,/g, ''));
      if (isNaN(value)) return null;
      return {
        prefix: m[1],
        suffix: m[3],
        value: value,
        comma: numStr.indexOf(',') > -1,
        decimals: numStr.indexOf('.') > -1 ? numStr.split('.')[1].length : 0
      };
    }

    function format(n, d) {
      return n.toLocaleString('en-US', {
        useGrouping: d.comma,
        minimumFractionDigits: d.decimals,
        maximumFractionDigits: d.decimals
      });
    }

    function animate(el, d) {
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / DURATION, 1);
        var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        el.textContent = d.prefix + format(d.value * eased, d) + d.suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function init(scope) {
      var nodes = (scope || document).querySelectorAll('.lg-section .lg-statval');
      if (!nodes.length || reduceMotion || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          animate(el, el._lgData);
        });
      }, { threshold: 0.4 });

      nodes.forEach(function (el) {
        if (el.dataset.lgCounted) return;
        var d = parse(el.textContent);
        if (!d) return; // non-numeric text: leave as is
        el.dataset.lgCounted = '1';
        el._lgData = d;
        el.textContent = d.prefix + format(0, d) + d.suffix;
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // Mobile image slider (uses the slick already loaded by the theme, no extra CDN)
    function initSliders(scope) {
      var $ = window.jQuery;
      if (!$ || !$.fn || !$.fn.slick) return;
      var mq = window.matchMedia('(max-width: 749px)');

      (scope || document).querySelectorAll('.lg-media--slider').forEach(function (el) {
        if (el._lgSliderBound) return;
        el._lgSliderBound = true;
        var $el = $(el);

        // start slider on mobile, destroy it on tablet/desktop (works on every resize)
        function apply() {
          if (!el.isConnected) return;
          var isOn = $el.hasClass('slick-initialized');
          if (mq.matches && !isOn) {
            $el.slick({
              arrows: false,
              dots: false,
              infinite: true,
              slidesToShow: 1, // the 1.2 look comes from CSS (padding-right on .slick-list)
              slidesToScroll: 1,
              autoplay: el.getAttribute('data-autoplay') === 'true',
              autoplaySpeed: parseInt(el.getAttribute('data-speed'), 10) || 3000
            });
          } else if (!mq.matches && isOn) {
            $el.slick('unslick');
          }
        }

        apply();
        if (mq.addEventListener) mq.addEventListener('change', apply);
        else if (mq.addListener) mq.addListener(apply);
      });
    }

    initSliders();
    window.addEventListener('load', function () { initSliders(); });

    // Theme editor: re-run when the section is re-rendered
    document.addEventListener('shopify:section:load', function (e) { init(e.target); initSliders(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mother-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mhHeroInit) return;
    window.__mhHeroInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mh-arrow]');
      if (!btn) return;

      var section = btn.closest('.mh-hero');
      var selector = (section.getAttribute('data-mh-target') || '').trim();
      var target = null;

      if (selector) {
        try { target = document.querySelector(selector); } catch (err) { target = null; }
      }
      if (!target) {
        // Default: next section
        var wrap = section.closest('.shopify-section') || section;
        target = wrap.nextElementSibling;
      }
      if (target) {
        var header = document.querySelector('sticky-header, header.header, .header-wrapper');
        var offset = header && getComputedStyle(header).position !== 'static' ? header.offsetHeight : 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-brands"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ARROW_PREV = '<button type="button" class="ob-arrow ob-arrow--prev" aria-label="Previous"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="M7 1L1 7l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    var ARROW_NEXT = '<button type="button" class="ob-arrow ob-arrow--next" aria-label="Next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="M1 1l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

    function num(el, key, def) {
      var v = parseInt(el.getAttribute('data-' + key), 10);
      return isNaN(v) ? def : v;
    }
    function bool(el, key) {
      return el.getAttribute('data-' + key) === 'true';
    }

    function build(el) {
      var $ = window.jQuery;
      var $el = $(el);
      if ($el.hasClass('slick-initialized')) return;

      var showD = num(el, 'show-desktop', 6);
      var showT = num(el, 'show-tablet', 4);
      var showM = num(el, 'show-mobile', 3);
      var showS = num(el, 'show-small', 2);
      var scroll = num(el, 'scroll', 1);
      var arrows = bool(el, 'arrows');
      var arrowsMobile = arrows && bool(el, 'arrows-mobile');

      $el.slick({
        slidesToShow: showD,
        slidesToScroll: Math.min(scroll, showD),
        autoplay: bool(el, 'autoplay'),
        autoplaySpeed: num(el, 'autoplay-speed', 3000),
        speed: num(el, 'speed', 500),
        infinite: bool(el, 'infinite'),
        pauseOnHover: bool(el, 'pause-hover'),
        arrows: arrows,
        prevArrow: ARROW_PREV,
        nextArrow: ARROW_NEXT,
        dots: bool(el, 'dots'),
        customPaging: function (slider, i) {
          return '<button type="button" aria-label="Go to slide ' + (i + 1) + '"></button>';
        },
        rtl: bool(el, 'rtl'),
        swipeToSlide: true,
        responsive: [
          { breakpoint: 989, settings: { slidesToShow: showT, slidesToScroll: Math.min(scroll, showT) } },
          { breakpoint: 749, settings: { slidesToShow: showM, slidesToScroll: Math.min(scroll, showM), arrows: arrowsMobile } },
          { breakpoint: 479, settings: { slidesToShow: showS, slidesToScroll: Math.min(scroll, showS), arrows: arrowsMobile } }
        ]
      });
    }

    function initAll(root, tries) {
      tries = tries || 0;
      var scope = root || document;
      var sliders = scope.querySelectorAll ? scope.querySelectorAll('[data-ob-slider]') : [];
      if (!sliders.length) return;

      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        Array.prototype.forEach.call(sliders, build);
      } else if (tries < 60) {
        // theme ka jQuery/slick load hone tak wait (max ~6 sec)
        setTimeout(function () { initAll(root, tries + 1); }, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    window.addEventListener('load', function () { initAll(); });

    // Theme editor support
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!window.jQuery) return;
      var list = e.target.querySelectorAll('[data-ob-slider].slick-initialized');
      Array.prototype.forEach.call(list, function (s) { window.jQuery(s).slick('unslick'); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-with-us-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.pw-form');
      if (!form) return;
      var btn = form.querySelector('.pw-submit');
      if (btn) {
        setTimeout(function () {
          btn.setAttribute('disabled', 'disabled');
          btn.style.opacity = '.7';
        }, 0);
      }
    });
  })(); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["training-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SEL = '[data-trs-slider]';

    function num(v, d) {
      var n = parseInt(v, 10);
      return isNaN(n) ? d : n;
    }

    function initSlider(root, tries) {
      tries = tries || 0;
      var $ = window.jQuery;
      if (!$ || !$.fn || !$.fn.slick) {
        if (tries < 50) {
          setTimeout(function () { initSlider(root, tries + 1); }, 200);
        }
        return;
      }
      var $track = $(root).find('.trs-track').first();
      if (!$track.length || $track.hasClass('slick-initialized') || root._trsInit) return;
      root._trsInit = true;

      var d = root.dataset;
      var $prev = $(root).find('.trs-arrow--prev');
      var $next = $(root).find('.trs-arrow--next');
      var hasDots = d.dots === 'true';
      var hasArrows = d.arrows === 'true' && $prev.length && $next.length;

      $track.slick({
        slidesToShow: num(d.slidesDesktop, 1),
        slidesToScroll: 1,
        autoplay: d.autoplay === 'true',
        autoplaySpeed: num(d.autoplaySpeed, 4000),
        speed: num(d.speed, 500),
        infinite: d.infinite === 'true',
        pauseOnHover: d.pauseOnHover === 'true',
        dots: hasDots,
        appendDots: hasDots ? $(root).find('.trs-dots') : undefined,
        customPaging: function (slider, i) {
          return $('<button type="button" />').attr('aria-label', 'Go to slide ' + (i + 1));
        },
        arrows: !!hasArrows,
        prevArrow: hasArrows ? $prev : undefined,
        nextArrow: hasArrows ? $next : undefined,
        adaptiveHeight: false,
        responsive: [
          { breakpoint: 990, settings: { slidesToShow: num(d.slidesTablet, 1) } },
          { breakpoint: 750, settings: { slidesToShow: num(d.slidesMobile, 1) } }
        ]
      });
    }

    function destroySlider(root) {
      var $ = window.jQuery;
      if (!$ || !$.fn || !$.fn.slick) return;
      var $track = $(root).find('.trs-track').first();
      if ($track.hasClass('slick-initialized')) $track.slick('unslick');
      root._trsInit = false;
    }

    function initAll(scope) {
      (scope || document).querySelectorAll(SEL).forEach(function (el) { initSlider(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll(SEL).forEach(destroySlider);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
